import { CaseDocumentAdmin, CaseAdmin, LabOrder } from "pwapi";

import { useSortedBlocks } from "shared/hooks/useSortedCase";

import HiddenDropDown from "../filters/HiddenDropdown";
import CopyBlockButton from "../ordersTable/CopyBlockButton";
import OrdersTable from "../ordersTable/OrdersTable";

type OrdersProps = {
  adminCase: CaseAdmin;
  documents: CaseDocumentAdmin[];
  ordersWithoutSlides?: LabOrder[];
  setPreviewDocumentId: Function;
};

const Orders = ({
  adminCase,
  documents,
  ordersWithoutSlides,
  setPreviewDocumentId,
}: OrdersProps) => {
  const labOrders = adminCase.lab_orders || [];
  const caseStatus = adminCase.status;
  const blocks = useSortedBlocks(adminCase);
  const filteredBlocks = blocks.filter((block) =>
    labOrders.some((lab_order) => lab_order.block_id === block.id)
  );

  return (
    <div className="panelContainer panelContainer--gap">
      {filteredBlocks.map((block) => {
        return (
          <HiddenDropDown
            label={block.full_name}
            isInitOpen
            type="largeLabel"
            key={block.id}
            labelActions={
              block.id ? <CopyBlockButton block_id={block.id} /> : null
            }
          >
            <OrdersTable
              caseStatus={caseStatus}
              documents={documents}
              ordersWithoutSlides={ordersWithoutSlides}
              orders={labOrders.filter(
                (labOrder) => labOrder.block_id === block.id
              )}
              setPreviewDocumentId={setPreviewDocumentId}
            />
          </HiddenDropDown>
        );
      })}
    </div>
  );
};

export default Orders;
